<template>
    <main>
        <agile :navButtons=false>
            <img class="slide" src="http://www.shengjia-resin.com/temp/1.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/2.jpg" />
            <img class="slide" src="http://www.shengjia-resin.com/temp/3.jpg" />
        </agile>
        <div class="article-wrapper">
            <article>
                <ul class="news-list">
                    <li class="news-list-item" v-for="(n, index) in datas" :key="index">
                        <img :src="n.imgurl" :alt="n.name">
                        <router-link :to="/recruitment/+n.id">
                            <h4>{{n.name}}</h4>
                            <p>招聘人数:{{n.jobnum}}人</p>
                        </router-link>
                    </li>
                </ul>
            </article>
        </div>
    </main>
</template>

<script>
    import qs from 'qs';
    import {
        VueAgile
    } from 'vue-agile'
    export default {
        name: 'Recruitment',
        components: {
            agile: VueAgile
        },
        data() {
            return {
                content: '',
                datas: [],
            }
        },
        mounted() {
            this.loadData();
        },
        methods: {
            loadData() {
                this.$axios.post('/findJobList').then(res => {
                    this.datas = res.data;
                }).catch(res => {
                    alert("数据获取失败")
                })
            },
            /*detail(val) {
                this.$router.push("/recruitment/" + val)
            }*/
        }
    }
</script>

<style lang="less">
    .news-list {
        margin: 0;
        padding: 0;

        &-item {
            list-style-type: none;
            padding: 16px 32px;

            >img {
                width: 150px;
                height: 100px;
                object-fit: contain;
            }

            p {
                margin: 0;
                text-indent: 0;
            }
        }
    }



</style>